/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { Box, MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleEditClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";
const EditRemark = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const remarkData = useSelector((state) => state.Modal.val);

  const { data: remarkInfo = [], refetch } = useQuery({
    queryKey: ["remarkInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-remarks`
      );
      const data = await res.json();
      return data;
    },
  });
  console.log(remarkInfo);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();

    formData.append("REMARK_ID", remarkData.remark_id);
    formData.append("REMARKS_NAME", data.remarks_name);
    formData.append("CREATED_BY", remarkData.created_by);

    fetch(`${process.env.REACT_APP_API_URL}/api/remarks-update`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Remark Update Successful", {
            position: toast.POSITION.TOP_CENTER,
          });
          refetch().then(() => {
            dispatch(handleEditClose());
          });
        } else if (data.duplicate === true) {
          toast.error("This Remark is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        {/* <Box mb="20px">
          <TextField
            select
            defaultValue={remarkData.sponsor_id}
            fullWidth
            size="small"
            label="Sponsor Name*"
            {...register("sponsor_id", {
              required: true,
            })}
          >
            {remarkInfo.map((sponsor) => (
              <MenuItem key={Math.random()} value={sponsor.sponsor_id}>
                {sponsor.sponsor_name}
              </MenuItem>
            ))}
          </TextField>
          {errors?.sponsor_id?.type === "required" && (
            <ErrorMessage>Sponsor name is required</ErrorMessage>
          )}
        </Box> */}

        <Box mb="20px">
          <TextField
            defaultValue={remarkData.remarks_name}
            size="small"
            fullWidth
            label="Remark Name*"
            variant="outlined"
            {...register("remarks_name", { required: true })}
          />
          {errors?.remarks_name?.type === "required" && (
            <ErrorMessage>Remark Name is required*</ErrorMessage>
          )}
        </Box>

        {/* <Box>
          <TextField
            select
            defaultValue={remarkData.astatus_fg}
            size="small"
            fullWidth
            label="Active Status"
            variant="outlined"
            {...register("astatus_fg", {
              // required: true
            })}
          >
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Inactive</MenuItem>
          </TextField>
          {errors?.astatus_fg?.type === "required" && (
            <ErrorMessage>Active status is required*</ErrorMessage>
          )}
        </Box> */}
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Update Remark
          </ThemButton>
        )}
      </Box>
      <ToastContainer
        autoClose={2000}
        limit={1}
        transition={Zoom}
        toastStyle={{ border: "2px solid crimson" }}
      />
    </form>
  );
};

export default EditRemark;
